import { ReactNode, useEffect } from "react";
import { ErrorPageType, useAnalyticsTracker } from "../../app/AnalyticsTracker";

interface Props {
  children: ReactNode;
  pageType: ErrorPageType;
}

function ErrorPage({ children, pageType }: Props) {
  const { AnalyticsTracker } = useAnalyticsTracker();

  useEffect(() => {
    AnalyticsTracker.trackIfPageError({ pageType });
  }, []);

  return <>{children}</>;
}

export default ErrorPage;
